/* eslint-disable no-underscore-dangle */
import { InnerAction } from './InnerAction';

export class RequestInnerAction extends InnerAction {
  override isVisible = false;
  constructor(public requestId: string) {
    super(null!, null!, null!);
  }
}
